export function toggleClass(el, className, onAddClassCallback, onRemoveClassCallback) {
  if (!el.classList) return;
  if (el.classList.contains(className)) {
    el.classList.remove(className);
    onAddClassCallback && typeof onAddClassCallback === 'function' && onAddClassCallback();
  } else {
    el.classList.add(className);
    onRemoveClassCallback && typeof onRemoveClassCallback === 'function' && onRemoveClassCallback();
  }
  return el;
}